export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-drag/src/constant.js
// module id = ljYI
// module chunks = 0